import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatPhone } from '../../utils/utils';

export default class DriverContactInfo extends React.Component<GridCustomCellProps> {
    render() {
        if (!this.props.field) return null;
        return (
            <td {...this.props.tdProps}>
                <a
                    href={"mailto:" + this.props.dataItem.Email}
                    style={{ color: '#007bff' }}
                >{this.props.dataItem.Email}
                </a>
                <br />
                <a href={`tel:${this.props.dataItem.Mobile}`}>{formatPhone(this.props.dataItem.Mobile)}</a>
            </td>
        );
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
        return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
    }
}
